<div class="teamsBox">
        <h4>{{ 'teams.removeTab.title' | translate }}</h4>
        <p [innerHTML]="'teams.removeTab.description' | translate"></p>
</div>